export default function normalizeRAG(value) {

    if (value) {

        if (value.toString().toLowerCase()==='red') return 0;
        if (value.toString().toLowerCase()==='amber') return 1;
        if (value.toString().toLowerCase()==='green') return 2;

        value = parseInt(value);
        if (!isNaN(value)) {
            return value;
        }
    }

    return null;

}